import { classNames } from '@utils/genUtils'
import React from 'react'


interface Props {
  subTitle: string
  title: string
  containerClassNames?: string
}
export default function PatternBonusHeader(props: Props) {
  const { subTitle, title, containerClassNames } = props
  return (
    <div className={classNames('col-span-2 col-start-2 md:col-start-4 md:col-span-8 lg:col-start-4 lg:col-span-8 lg:text-center xl:col-start-5 xl:col-span-6 xl:mb-8', containerClassNames ? containerClassNames : '')}>
      <span className='text-lg font-semibold text-rusted-400'>{subTitle}</span>

      <h2 className='mb-4 text-3xl font-sentinel__SemiBoldItal md:text-5xl'>{title}</h2>
    </div>
  )
}
